import { Fragment, useState } from "react";
import { FilterSidebar } from "../SearchFilters";

const MobileFilters = () => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);


    return (
        <Fragment>
            <button
                onClick={() => setIsFilterOpen(true)}
                className="lg:hidden p-3 bg-gradient-radial bg-black rounded-xl rounded-tr-md hover:bg-gray-700 transition duration-150"
                aria-label="Toggle Filter"
            >
                <img
                    className={`w-6 h-6 transform transition-transform duration-300`}
                    src='/assets/gym-trainer-list/filters.png'
                    alt='filters'
                />
            </button>
            {
                isFilterOpen &&
                <div className="fixed inset-0 z-50 lg:hidden" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-start justify-end min-h-screen pt-12 text-center sm:block sm:p-0">
                        {/* Background overlay */}
                        <div className="fixed inset-0 bg-black bg-opacity-75 transition-opacity" aria-hidden="true" onClick={() => setIsFilterOpen(false)}></div>

                        {/* Filter Panel */}
                        <div className="fixed top-0 left-0 w-64 h-full bg-gray-900 shadow-xl overflow-y-auto transform transition-all ease-in-out duration-300">
                            <div className="flex justify-end p-4">
                                <button
                                    onClick={() => setIsFilterOpen(false)}
                                    className="text-gray-400 hover:text-white"
                                    aria-label="Close Filter"
                                >
                                    {/* <img
                                        className={`w-5 h-5 transform transition-transform duration-300`}
                                        src='/assets/gym-facilities/times.png'
                                        alt='times'
                                    /> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <FilterSidebar />
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
};

export { MobileFilters };